import { useTranslation } from 'react-i18next';
import { IcCheck, IcWarn } from './Icons';
import { chipText, compTone, effectiveSound } from './model';

const NAMES = ['internet', 'sound', 'picture'];

/** The three always-visible indicators on every screen card: green ✓ name, red ⚠ "name: problem", grey "name: state". */
export default function HealthChips({ comps, muted }) {
  const { t } = useTranslation();
  if (!comps) return null;
  return (
    <div className="pp-scr-chips" data-testid="health-chips">
      {NAMES.map((n) => {
        const c = n === 'sound' ? effectiveSound(comps.sound, muted) : (comps[n] || { state: 'unknown', word: 'unknown' });
        const tone = compTone(c);
        return (
          <span key={n} className={`pp-scr-chip pp-scr-${tone}`} data-comp={n} data-state={c.state}>
            {tone === 'g' ? <IcCheck /> : tone === 'c' ? <IcWarn /> : null}{chipText(t, n, c)}
          </span>
        );
      })}
    </div>
  );
}
